<template>
     <div style="width:1300px;margin:0 auto;">
            <div v-show="showPage" class="card mb-5 p-3 upload" style="box-shadow: 10px 10px 5px #888888;margin-top:100px;">
                <p class="text-center mb-2">
                     <span style="font-size:20px;">
                       上传图片
                     </span>
                      <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;cursor: pointer;" @click="$router.go(-1)">
                           &times;
                      </span>
                </p>

<!--                     <div style="display:flex;">

                        <div>
                            <div id="source" class="img_content">
                                <div class="img_wh" v-for="(item,name,index) in imglist" :key="index">
                                     <img  @click="getPictures(index)" class="img_wh img_border" :class="{'active':active==index}" :src="item==''?'../../../static/images/zanwutupian.png':'http://fw.hyey.cn'+item" >
                                </div>
                            </div>
                            <div class="mt-5">
                                <el-upload
                                  class="upload-demo"
                                  drag
                                  action=""
                                  multiple>
                                  <i class="el-icon-upload"></i>
                                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                </el-upload>
                            </div>
                        </div>
                        <div class="ml-5">
                            <table>
                                <tr>
                                    <td colspan="2">
                                         <h5 class="mb-3 mt-3">
                                              图片上传情况
                                         </h5>
                                    </td>
                                </tr>
                                <tbody style="font-size:15px;">
                                    <tr>
                                    <td>图片位置:</td>
                                    <td class="jz_font">{{cs.text1}}</td>
                                    </tr>
                                    <tr>
                                        <td>图片状态:</td>
                                        <td>{{cs.text2}}</td>
                                    </tr>
                                    <tr>
                                        <td>反馈信息:</td>
                                        <td>{{cs.text3}}</td>
                                    </tr>
                                </tbody>
                                <tr>
                                    <td colspan="2">
                                         <h5 class="mb-3 mt-3">
                                            图片修改情况
                                         </h5>
                                    </td>
                                </tr>
                                <tbody style="font-size:15px;">
                                    <tr>
                                    <td>图片位置:</td>
                                    <td class="jz_font">{{cs2.text1}}</td>
                                    </tr>
                                    <tr>
                                        <td>图片状态:</td>
                                        <td>{{cs2.text2}}</td>
                                    </tr>
                                    <tr>
                                        <td>反馈信息:</td>
                                        <td>{{cs2.text3}}</td>
                                    </tr>
                                </tbody>
                                <tr>
                                    <td style="font-size:15px;">修改请求</td>
                                     <td>
                                          <button v-if="qingMess==true" class="btn btn-primary" style="font-size:10px;" @click="modification()">
                                               请求修改
                                          </button>
                                          <span v-if="qingMess==false">
                                                {{cs2.text4}}
                                          </span>
                                     </td>
                                </tr>
                            </table>
                        </div>
                    </div> -->


                <div class="row p-0">
                       <div class="col-5">
                           <div id="source" class="img_content">
                                <div class="img_wh" v-for="(item,name,index) in imglist" :key="index">
                                     <img  @click="getPictures(index)" class="img_wh img_border" :class="{'active':active==index}" :src="item==''?'../../../static/images/zanwutupian.png':'http://fw.hyey.cn'+item" >
                                </div>
                           </div>
                            <table>
                                <tr>
                                    <td colspan="2">
                                         <h5 class="mb-3 mt-3">
                                              图片上传情况
                                         </h5>
                                    </td>
                                </tr>
                                <tbody style="font-size:15px;">
                                    <tr>
                                    <td>图片位置:</td>
                                    <td class="jz_font">{{cs.text1}}</td>
                                    </tr>
                                    <tr>
                                        <td>图片状态:</td>
                                        <td>{{cs.text2}}</td>
                                    </tr>
                                    <tr>
                                        <td>反馈信息:</td>
                                        <td>{{cs.text3}}</td>
                                    </tr>
                                </tbody>
                                <tr>
                                    <td colspan="2">
                                         <h5 class="mb-3 mt-3">
                                            图片修改情况
                                         </h5>
                                    </td>
                                </tr>
                                <tbody style="font-size:15px;">
                                    <tr>
                                    <td>图片位置:</td>
                                    <td class="jz_font">{{cs2.text1}}</td>
                                    </tr>
                                    <tr>
                                        <td>图片状态:</td>
                                        <td>{{cs2.text2}}</td>
                                    </tr>
                                    <tr>
                                        <td>反馈信息:</td>
                                        <td>{{cs2.text3}}</td>
                                    </tr>
                                </tbody>
                                <tr>
                                    <td style="font-size:15px;">修改请求</td>
                                     <td>
                                          <button v-if="qingMess==true" class="btn btn-primary" style="font-size:10px;" @click="modification()">
                                               请求修改
                                          </button>
                                          <span v-if="qingMess==false">
                                                {{cs2.text4}}
                                          </span>
                                     </td>
                                </tr>
                            </table>

                       </div>
                       <div class="col-7 mt-1">
     <!--                          <div  @drop="drop($event)"  @dragover="allowDrop($event)" class="upload_img" :class="{'show_border':showBorder}" id="target">
                                  <div>
                                      <img @click="fileBtn()" style="display:block;margin:0 auto;"  src="../../../static/images/shangchuan.png">
                                      <input style="display:none"  @change='uploadFile($event)' type="file" id="file">
                                    <p class="text-center">
                                        点击上传，或将图片拖拽到此处
                                    </p>

                                  </div>
                              </div> -->
                            <el-upload
                              class="ml-5"
                              drag
                              action=""
                              :multiple="false"
                              :http-request="uploadFile"
                              :show-file-list="false">
                              <i class="el-icon-upload"></i>
                              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            </el-upload>
                       </div>
                </div>
                    <p class="text-center mt-5">
                        <!-- <button class="btn btn-primary" @click="fileBtn()">上传图片</button> -->
                        <el-upload
                          class="upload-demo"
                          action=""
                          :multiple="false"
                          :http-request="uploadFile"
                          :show-file-list="false">
                          <el-button size="small" type="primary">上传图片</el-button>
                        </el-upload>
                    </p>
             </div>

     </div>
</template>
<script>
// import {file} from "../../components/common/file.js"
// import {upload} from "../../components/common/upload.js"
export default {
     data(){
          return{
              lxs:'',
              state:'',
              pageIndex:'',
              id:'',
              content: '',
              showBorder:false,
              ypbh:'',
              wz:'',
              fileName:'',
              imglist:{},
              cs:'',
              cs2:'',
              qingMess:"",
              active:"",
              showPage:false,
            //   imgs: [],
			// 	//判断图片的类型
			// 	imgData: {
			// 		accept: 'image/gif, image/jpeg, image/png, image/jpg',
			// 	},
            form: {
                ypmc: "",
                cdmc: "",
                gg: ""
            }
          }
      },
      computed:{
                btnText(){
                    // return this.qingMess == 'false' ? `${this.cs2.text4}` : "请求修改"
              }
      },
        components: {

        },
      methods:{
           //请求修改
           modification:async function(){
                await this.$http.post('Dls/DlsUpimg', {
                    lxs:2,
                    ypbh:this.ypbh,
                    wz:this.wz,
                    fileName:'',
                }).then(response => {
                // console.log(response)
                if(response.data.isok){
                    if(response.data.data.isok){
                    this.$message.success(response.data.data.msg);
                     this.getPictures();//重新获取列表
                    }
                    else{
                        alert(response.data.data.msg)
                    }

                }
                else{
                    alert(response.data.message)
                }
                })
           },



          //上传图片
          async uploadFile(event, flag) {
                console.log(event)
                let that=this;
                let file = flag ? event.target.files[0] : event.file; //获取input的图片file值
                let param = new FormData(); // 创建form对象
                param.append("fileName", file); //对应后台接收图片名
				param.append("username",window.sessionStorage.getItem('username'));
				param.append("tokenid",window.sessionStorage.getItem('tokenid'));
				param.append("ypbh",that.ypbh);
				param.append("wz",that.wz);
				param.append("lxs",3);
				param.append("phone_uuid","");
                param.append("ypmc", this.form.ypmc);
                param.append("cdmc", this.form.cdmc);
                param.append("gg", this.form.gg);
                // param.append("orderno", this.form.orderno);
				// console.log(param)
				let config = {
						headers: {
						'Content-Type': 'multipart/form-data;boundary ='+ new Date().getTime()
						}
						}
                await this.$http.post('Dls/DlsUpimg2',
                        param
                    ,config).then(res => {//uploadPicture为我的api接口
                    console.log(res)
                    //{"isok":true,"code":1,"message":"","data":{"imglist":null,"cs":null,"cs2":null,"isok":true,"msg":"上传成功"}}他是true 就是成功了
                    if(res.data.isok){
                         if(res.data.data.isok){
                             this.$message.success(res.data.data.msg)
                             this.getPictures(that.wz)
                         }
                         else{
                             alert(res.data.data.msg)
                         }
                    }
                    else{
                        alert(res.data.message)
                    }
                    //这里你判断着写
                });
                this.$notify({
                    duration: 3000,
                    title: "成功",
                    message: "上传成功！",
                    type: "success"
                });
                },

          //获取图片列表
         getPictures: async function (index) {
          // this.isLoading=true;
          //index=""+index;
          this.active=index
          this.wz=index;
         await this.$http.post('Dls/DlsUpimg', {
             lxs:1,
             ypbh:this.ypbh,
             wz:index,
             fileName:'',
             ypmc: this.form.ypmc,
             cdmc: this.form.cdmc,
             gg: this.form.gg
        }).then(response => {
            //   console.log(response)
          if(response.data.isok){
                  if(response.data.data.isok){
                      this.imglist=response.data.data.imglist;
                      this.cs=response.data.data.cs;
                      this.cs2=response.data.data.cs2;
                      this.qingMess = response.data.data.cs2.qingMess;
                      this.showPage=true;
                   //    console.log(this.qingMess)
                   //    console.log(this.imglist);
                  }
                  else{
                      alert(response.data.data.msg);
                  }
        }
        else{
            alert(response.data.message)
        }
        })
      },
       fileBtn(){
          document.getElementById('file').click();
            let file = document.getElementById('file');
            //  console.log(file.value);
       },
      //上传图片
    //   upload:async function(e){

    //           //img.src = window.URL.createObjectURL(e)
    //                 await this.$http.post('Dls/DlsUpimg', {
    //                     lxs:3,
    //                     ypbh:this.ypbh,
    //                     wz:"1",
    //                     fileName:e,
    //                 }).then(response => {
    //                     console.log(response)
    //                 if(response.data.isok){
    //                     if(!response.data.data.isok){
    //                     alert(response.data.data.msg)
    //                     }
    //                 }
    //                 })
    //   }
           allowDrop(e) {
      e.preventDefault();
    },
    drop(e) {
      // 方法一
      //这种方法浏览器很多情况下获取都是一个空数组，所以改用以下方法
    //   var files = e.dataTransfer.files;

      // 方法二
      let files = [];
      [].forEach.call(
        e.dataTransfer.files,
        function(file) {
          files.push(file);
        },
        false
      );

    //上传图片
      this.uploadFile1(files[0])

    //   console.log(files);
      this.reader(files[0]); //可在当前页面显示图片

    },
     reader(f) {
      var reader = new FileReader();
      reader.readAsDataURL(f);
      reader.onload = function() {
        // console.log(reader.result); //当前图片的src，可自行通过dom设置src显示出来

    // let target = document.getElementById("target");
        // target.innerHTML = '<img src="'+this.result+'" alt=""/>'

      };
    },
    async uploadFile1(files){
                let that=this;
                let param = new FormData(); // 创建form对象
                param.append("fileName", files); //对应后台接收图片名
				param.append("username",window.sessionStorage.getItem('username'));
				param.append("tokenid",window.sessionStorage.getItem('tokenid'));
				param.append("ypbh",that.ypbh);
				param.append("wz",that.wz);
				param.append("lxs",3);
				param.append("phone_uuid","");
				//  console.log(param)
				let config = {
						headers: {
						'Content-Type': 'multipart/form-data;boundary ='+ new Date().getTime()
						}
						}
                await this.$http.post('Dls/DlsUpimg2',
                        param
                    ,config).then(res => {
                    console.log(res)
                    if(res.data.isok){
                         if(res.data.data.isok){
                             this.$message.success(res.data.data.msg)
                             this.getPictures(that.wz)
                         }
                         else{
                             alert(res.data.data.msg)
                         }
                    }
                    else{
                        alert(res.data.message)
                    }

                 });
                },


      },
      mounted(){
    //         const that=this;
    //         let source_img = document.getElementById('source').getElementsByTagName("img");
    //         // console.log(source_img)
    //         let target = document.getElementById('target');
    //         source_img.ondragstart = function(event){
    //             let e = event || window.event
    //             // console.log('开始拖拽');
    //             e.dataTransfer.setData('text',e.target.id);
    //         }
    //             target.ondragenter = function(){
    //                 that.showBorder=true;
    //                 // console.log(that.showBorder)
    //                 // console.log('进入目标元素')

    //             }
    //             target.ondragover = function(event){
    //                 var event = event || window.event;
    //                 // console.log('在目标元素中拖拽');
    //                 event.preventDefault()
    //             }
    //             target.ondragleave = function(){
    //                 that.showBorder=false;
    //                 // console.log('拖放离开目标元素')
    //             }
    //             target.ondrop = function(event){
    //                 // console.log('拖放');
    //                 let e = event || window.event
    //                 let data = e.dataTransfer.getData('text');
    //                 that.showBorder=false;
    //                 // that.fileBtn()
    //                 //  e.target.appendChild(document.getElementById(data));
    //             }

    // document.ondragover = function(e) {
    //   e.preventDefault(); //阻止拖放的图片在新窗口中直接显示,拖放的目标对象此时是document对象
    // };
    // document.ondrop = function(e) {
    //   e.preventDefault(); //阻止 document.ondrop的默认行为  *** 在新窗口中打开拖进的图片
    // };




      },
      created(){
        let obj = window.sessionStorage.getItem('upImgObj');
        if (obj) {
            let item = JSON.parse(obj)
            this.form = {
                ypmc: item.ypmc,
                cdmc: item.cdmc,
                gg: item.gg,
                // orderno:item.orderno
            }
        }

           this.ypbh=this.$route.query.ypbh;
        //    console.log(this.ypbh)
           this.getPictures(0)
      },
      destroyed() {
        window.sessionStorage.removeItem('upImgObj')
      }

}
</script>
<style lang="less" scoped>
.jz_middle{
   vertical-align:middle;
 }
 .span_close:hover{
       color:#3190e8;
 }

.img_content{
    display: flex;
    flex-wrap: nowrap;
}
.img_wh{
    margin-top:3px;
    width:100px;
    height:100px;
    margin-right:5px;
}
.jz_font{
    color:#FF0000;
    font-size:16px;
    font-weight:bold;
}
.upload{
    background-color:#f8f8f8;
}
.upload_img{
    background-color:#fff;
    height:200px;
    display:flex;
    justify-content: center;
    align-items:center;
}
.show_border{
    border:2px dotted #3190e8;
}
.active{
    border:1px solid red !important;
}

.img_border {
    border:1px dashed #ccc;
}

.img_border:hover{
    border:1px solid red;
}
</style>




// WEBPACK FOOTER //
// src/pages/Endregion/UpLoadImg.vue